module.exports = __webpack_public_path__ + "img/chuky2.dd47235d.jpg";